export default function flatter(obj: any) {//扁平化对象
  const result:any = {};

  function recurse(src: any[], prop: any) {
    const toString = Object.prototype.toString;
      if (toString.call(src) == '[object Object]') {
          let isEmpty = true;
          for (const p in src) {
              isEmpty = false;
              recurse(src[p], prop ? prop + '[' + p + ']' : p)
          }
          if (isEmpty && prop) {
              result[prop] = {};
          }
      } else if (toString.call(src) == '[object Array]') {
        const len = src.length;
          if (len > 0) {
              src.forEach(function (item, index) {
                  recurse(item, prop ? prop + '[' + index + ']' : '[' + index + ']');
              })
          } else {
              result[prop] = [];
          }
      } else {
          result[prop] = src;
      }
  }
  recurse(obj, '');

  return result;
}